import React from 'react';
import { Star } from 'lucide-react';
import { testimonials } from '../mock';

const Testimonials = () => {
  return (
    <section className="py-32 bg-gradient-to-b from-black via-brand-brown/20 to-black relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0">
        <div className="absolute top-1/3 left-1/3 w-[500px] h-[500px] bg-brand-olive/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/3 right-1/3 w-[500px] h-[500px] bg-brand-yellow/5 rounded-full blur-3xl"></div>
      </div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Section header */}
          <div className="text-center mb-20">
            <h2 className="text-5xl lg:text-6xl font-bold text-white mb-6 tracking-tight">
              Real Success Story
            </h2>
            <p className="text-xl lg:text-2xl text-brand-cream/90 max-w-3xl mx-auto font-light">
              See how we helped Chef Compliance UK achieve remarkable growth 
              and dominate their industry online.
            </p>
          </div>
          
          {/* Testimonial - Single featured testimonial */}
          <div className="max-w-5xl mx-auto">
            {testimonials.map((testimonial) => (
              <div 
                key={testimonial.id}
                className="bg-gradient-to-br from-brand-brown/70 to-black/90 rounded-3xl p-16 shadow-2xl transition-all duration-500 border-2 border-brand-yellow/60 backdrop-blur-xl hover:scale-105"
              >
                {/* Stars */}
                <div className="flex gap-1 mb-6 justify-center">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-7 h-7 fill-brand-yellow text-brand-yellow" />
                  ))}
                </div>
                
                {/* Content */}
                <p className="text-brand-cream/90 leading-relaxed mb-8 italic text-xl text-center">
                  "{testimonial.content}"
                </p>
                
                {/* Author */}
                <div className="flex items-center justify-center gap-6">
                  <img 
                    src={testimonial.image} 
                    alt={testimonial.name}
                    className="w-20 h-20 rounded-full object-cover border-4 border-brand-olive/40 shadow-lg"
                  />
                  <div className="text-center">
                    <div className="font-bold text-white text-xl">{testimonial.name}</div>
                    <div className="text-brand-cream/70">{testimonial.role}</div>
                    <div className="text-brand-yellow font-semibold text-lg mt-1">{testimonial.business}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          {/* Social proof banner */}
          <div className="mt-16 text-center p-8 bg-brand-brown/40 rounded-xl border border-brand-olive/40 backdrop-blur-sm">
            <p className="text-lg text-brand-cream/80">
              Join <span className="font-bold text-brand-yellow">Chef Compliance UK</span> and other businesses who have transformed 
              their digital presence with JRT Chideme Media
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
